var scripts = [
	'head',
	'util/flickity.pkgd'
];

(function($) {
  var $view = $("body");

  for (i = 0; i < scripts.length; i++) { 
  	var scriptSrc = '../assets/js/'+scripts[i]+'.min.js';
	$.getScript(scriptSrc);
  }
})(jQuery);


